import { defineStore } from 'pinia';
import type { Organisation } from '@/api/model/Organisation';
import { fetchOrganisationNotifications, type OrganisationNotificationData } from '@/queries/notifications';

export type { OrganisationNotificationData } from '@/queries/notifications';

interface NotificationState {
    organisationNotifications: OrganisationNotificationData[];
    totalCount: number;
    loading: boolean;
}

export const useNotificationStore = defineStore('notification', {
    state: (): NotificationState => ({
        organisationNotifications: [],
        totalCount: 0,
        loading: false,
    }),
    actions: {
        async fetchOrganisationNotifications(organisation: Organisation) {
            if (!organisation?.public_id) {
                this.organisationNotifications = [];
                this.totalCount = 0;
                return;
            }

            this.loading = true;
            try {
                const response = await fetchOrganisationNotifications(organisation);
                this.organisationNotifications = response.data;
                this.totalCount = response.meta.total;
            } catch {
                this.organisationNotifications = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },
        clearAll() {
            this.organisationNotifications = [];
            this.totalCount = 0;
        },
    },
});
